<template>
    <div class="new-goods">
        <h2 class="def-header-2">{{result.message.title}}</h2>
        <DefSliderWrapper v-if="screenWidth >= 992">
            <swiper
                :modules="modules"
                :slides-per-view="4"
                :space-between="4"
                :pagination="{ clickable: true }"
                navigation
            >
                <swiper-slide
                    v-for="item in result.items"
                    :key="item.id"
                >
                    <product-card-2 :result="item" />
                </swiper-slide>
            </swiper>
        </DefSliderWrapper>

        <PerfectScrollbar v-else class="new-goods__mobile">
            <product-card-2
                v-for="item in result.items"
                :key="item.id"
                :result="item"
            />
        </PerfectScrollbar>
        <div class="new-goods__bottom">
            <a :href="result.link.href" class="def-button">{{result.link.name}}</a>
        </div>
    </div>
</template>

<script>
import {Navigation, Pagination} from "swiper";
import { Swiper, SwiperSlide } from 'swiper/vue';

export default {
    name: 'NewGoods',
    props: {
        result: {
            type: Object,
            default: () => ({
                "message": {"title": "Новые поступоления"},
                "items": [{
                    "id": "52612",
                    "name": "Браслет из белого золота с бриллиантами. Артикул: 421650120201",
                    "detailPage": "/catalog/test/braslet-iz-belogo-zolota-s-brilliantami-artikul-421650120201.html",
                    "article": "52612",
                    "price": {"price": 0, "printPrice": "0 грн."},
                    "offer": {"id": "57663", "price": {"price": 0, "printPrice": "0 грн."}, "current": true},
                    "offers": [{
                        "id": "57663",
                        "price": {"price": 0, "printPrice": "0 грн."},
                        "current": true
                    }, {
                        "id": "57066",
                        "price": {"price": 0, "printPrice": "0 грн."},
                        "current": false
                    }, {
                        "id": "57065",
                        "price": {"price": 0, "printPrice": "0 грн."},
                        "current": false
                    }, {
                        "id": "57064",
                        "price": {"price": 0, "printPrice": "0 грн."},
                        "current": false
                    }, {"id": "57063", "price": {"price": 71918, "printPrice": "71918 грн."}, "current": false}],
                    "propsForCheck": {
                        "SIZES": {
                            "165": {
                                "name": "165",
                                "displayValue": "165",
                                "value": "165",
                                "disable": null,
                                "active": null,
                                "type": "img"
                            },
                            "170": {
                                "name": "170",
                                "displayValue": "170",
                                "value": "170",
                                "disable": null,
                                "active": null,
                                "type": "img"
                            },
                            "175": {
                                "name": "175",
                                "displayValue": "175",
                                "value": "175",
                                "disable": null,
                                "active": null,
                                "type": "img"
                            },
                            "180": {
                                "name": "180",
                                "displayValue": "180",
                                "value": "180",
                                "disable": null,
                                "active": true,
                                "type": "img"
                            },
                            "190": {
                                "name": "190",
                                "displayValue": "190",
                                "value": "190",
                                "disable": null,
                                "active": null,
                                "type": "img"
                            }
                        }
                    },
                    "picture": {
                        "alt": "Браслет из белого золота с бриллиантами. Артикул: 421650120201",
                        "src": "/upload/resize_cache/iblock/815/200_200_140cd750bba9870f18aada2478b24840a/815c98274d95fd3c2ddaa9446baad3b8.jpg"
                    }
                }, {
                    "id": "52034",
                    "name": "Серьги из красного золота с жемчугом. Артикул: 219168210101",
                    "detailPage": "/catalog/test/sergi-iz-krasnogo-zolota-s-zhemchugom-artikul-219168210101.html",
                    "article": "52034",
                    "price": {"price": 54152, "printPrice": "54152 грн."},
                    "offer": {
                        "id": "57086",
                        "price": {"price": 54152, "printPrice": "54152 грн."},
                        "current": true
                    },
                    "offers": [{
                        "id": "57086",
                        "price": {"price": 54152, "printPrice": "54152 грн."},
                        "current": true
                    }],
                    "propsForCheck": [],
                    "picture": {
                        "alt": "Серьги из красного золота с жемчугом. Артикул: 219168210101",
                        "src": "/upload/resize_cache/iblock/2f1/200_200_140cd750bba9870f18aada2478b24840a/2f139e57a1c6eb00f9d0b1e68900a36e.jpg"
                    }
                }, {
                    "id": "52026",
                    "name": "Серьги из белого золота. Артикул: 219157820201",
                    "detailPage": "/catalog/test/sergi-iz-belogo-zolota-artikul-219157820201.html",
                    "article": "52026",
                    "price": {"price": 63866, "printPrice": "63866 грн."},
                    "offer": {
                        "id": "56892",
                        "price": {"price": 63866, "printPrice": "63866 грн."},
                        "current": true
                    },
                    "offers": [{
                        "id": "56892",
                        "price": {"price": 63866, "printPrice": "63866 грн."},
                        "current": true
                    }],
                    "propsForCheck": [],
                    "picture": {
                        "alt": "Серьги из белого золота. Артикул: 219157820201",
                        "src": "/upload/resize_cache/iblock/cfd/200_200_140cd750bba9870f18aada2478b24840a/cfdf1c9c0ecd88ba44ac70c4488a1108.jpg"
                    }
                }, {
                    "id": "51828",
                    "name": "Серьги из белого золота с бриллиантами . Артикул: 210515420201",
                    "detailPage": "/catalog/test/sergi-iz-belogo-zolota-s-brilliantami-artikul-210515420201.html",
                    "article": "51828",
                    "price": {"price": 71287, "printPrice": "71287 грн."},
                    "offer": {
                        "id": "55856",
                        "price": {"price": 71287, "printPrice": "71287 грн."},
                        "current": true
                    },
                    "offers": [{
                        "id": "55856",
                        "price": {"price": 71287, "printPrice": "71287 грн."},
                        "current": true
                    }],
                    "propsForCheck": [],
                    "picture": {
                        "alt": "Серьги из белого золота с бриллиантами . Артикул: 210515420201",
                        "src": "/upload/resize_cache/iblock/090/200_200_140cd750bba9870f18aada2478b24840a/0904cb6066c64405952fc6f5be81b6eb.jpg"
                    }
                }, {
                    "id": "51277",
                    "name": "Кольцо из белого золота с бриллиантами. Артикул: 119157820201",
                    "detailPage": "/catalog/test/119157820201.html",
                    "article": "51277",
                    "price": {"price": 52478, "printPrice": "52478 грн."},
                    "offer": {
                        "id": "56891",
                        "price": {"price": 52478, "printPrice": "52478 грн."},
                        "current": true
                    },
                    "offers": [{
                        "id": "56891",
                        "price": {"price": 52478, "printPrice": "52478 грн."},
                        "current": true
                    }, {"id": "56890", "price": {"price": 0, "printPrice": "0 грн."}, "current": false}],
                    "propsForCheck": {
                        "SIZES": {
                            "17": {
                                "name": "17",
                                "displayValue": "17",
                                "value": "17",
                                "disable": null,
                                "active": true,
                                "type": "img"
                            },
                            "17_5": {
                                "name": "17,5",
                                "displayValue": "17_5",
                                "value": "17_5",
                                "disable": null,
                                "active": null,
                                "type": "img"
                            }
                        }
                    },
                    "picture": {
                        "alt": "Кольцо из белого золота с бриллиантами. Артикул: 119157820201",
                        "src": "/upload/resize_cache/iblock/5fb/200_200_140cd750bba9870f18aada2478b24840a/5fb52e55ce7bc504cd1378c0d9ec48ae.jpg"
                    }
                }], "link": {"href": "javascript:void(0)", "name": "до всіх новинок"}
            })
        }
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            modules: [Navigation, Pagination],
        }
    },
}
</script>

<style lang="scss">
    .new-goods{
        margin: 104px 0;
        &__bottom{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 24px;
            @include point-lg{
                margin-top: 32px;
            }
        }
        &__mobile{
            display: flex;
            overflow-x: auto;
            padding-bottom: 20px;
            & > *{
                width: 236px;
                flex-shrink: 0;
                &:not(:last-child) {
                    margin-right: 4px;
                }
            }
        }
        .def-button{
            font-size: rem(14);
            text-transform: uppercase;
            height: 48px;
            @include point-lg{
                height: 56px;
                font-size: rem(18);
                padding: 0 48px;
            }
        }
    }
</style>